import React from "react";
import { useParams } from "react-router-dom";
import EventManager from "../components/admin/EventManager";
import Dashboard from "../components/admin/Dashboard";
import UserList from "../components/admin/UserList";

const AdminEventDetails: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();

  if (!eventId) {
    return <div>Event not found</div>;
  }

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <EventManager eventId={eventId} mode="edit" />
        <Dashboard eventId={eventId} />
      </div>
      <UserList eventId={eventId} />
    </div>
  );
};

export default AdminEventDetails;
